// src/App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Layout from "./components/Layout";

// — Nueva pantalla Peajes
import ResumenesPeajes from "./components/ResumenesPeajes";

//  — Páginas
import Home                 from "./pages/Home";
import AcercaDe             from "./pages/AcercaDe";
import HomeImpresion        from "./pages/HomeImpresion";
import HomeAltas            from "./pages/HomeAltas";
import HomePeajes           from "./pages/HomePeajes";
import HomeSeguros          from "./pages/HomeSeguros";
import Login                from "./pages/Login";
import Admin                from "./pages/Admin";
import Clientes             from "./pages/Clientes";
import Proveedores          from "./pages/Proveedores";
import Empleados            from "./pages/Empleados";
import Comandas             from "./pages/Comandas";
import Remitos              from "./pages/Remitos";
import Transportes          from "./pages/Transportes";
import Choferes             from "./pages/Choferes";
import Camiones             from "./pages/Camiones";
import Estaciones           from "./pages/Estaciones";
import Productos            from "./pages/Productos";
import Localidades          from "./pages/Localidades";
import Empresas             from "./pages/Empresas";
import Destinos             from "./pages/Destinos";
import Estados              from "./pages/Estados";
import Gastos               from "./pages/Gastos";
import CuentaGastos         from "./pages/CuentaGastos";
import Metodos              from "./pages/Metodos";
import Movimientos          from "./pages/Movimientos";
import Viajes               from "./pages/Viajes";
import Cajas                from "./pages/Cajas";
import Seguros              from "./pages/Seguros";
import ImportarPeajes       from "./pages/ImportarPeajes";


import InformeViajesTransporte from "./pages/InformeViajesTransporte";
import InformePeajes        from "./pages/InformePeajes";
import InformeSeguros       from "./pages/InformeSeguros";
import InformeAuditoria     from "./pages/InformeAuditoria";
import InformeComandas      from "./pages/InformeComandas";
import InformeRemitos       from "./pages/InformeRemitos";
import InformeCajas         from "./pages/InformeCajas";
import InformeMovimientos   from "./pages/InformeMovimientos";
import InformeRendiciones   from "./pages/InformeRendiciones";
import InformeOrdenCobro    from "./pages/InformeOrdenCobro";
import InformeOrdenPago     from "./pages/InformeOrdenPago";
import InformeCtaCte        from "./pages/InformeCtaCte";
import InformeCLiPro        from "./pages/InformeCliPro";
import InformeTesoreria     from "./pages/InformeTesoreria";
import InformeCtaCteChofer  from "./pages/InformeCtaCteChofer";
import InformeChoferes      from "./pages/InformeChoferes";
import InformeEstaciones    from "./pages/InformeEstaciones";
import InformeCtaCteEstacion from "./pages/InformeCtaCteEstacion";
import InformeCartera       from "./pages/InformeCartera";
import InformeChequesECheq  from "./pages/InformeChequesECheq";

import DashboardChequesECheq from "./pages/DashboardChequesECheq";
import DashboardAuditoria    from "./pages/DashboardAuditoria";
import DashboardCombustible  from "./pages/DashboardCombustible";
import DashboardRentabilidad from "./pages/DashboardRentabilidad";
import DashboardViajes       from "./pages/DashboardViajes";

import HistoricoViajes from "./pages/HistoricoViajes";
import InformeVencimientosChequesECheq from "./pages/InformeVencimientosChequesECheq";

// — util
const isLoggedIn = () =>
  !!localStorage.getItem("token");

const PrivateRoute = ({
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

export default function App() {
  return (
    <Router>
      <Layout>
        <Switch>
          {/* público */}
          <Route
            exact
            path="/login"
            component={Login}
          />

          {/* privadas */}
          <PrivateRoute exact path="/" component={Home} />
          <PrivateRoute exact path="/AcercaDe" component={AcercaDe} />
          <PrivateRoute exact path="/HomeImpresion" component={HomeImpresion} />
          <PrivateRoute exact path="/HomeAltas" component={HomeAltas} />
          <PrivateRoute exact path="/peajes" component={HomePeajes} />
          
          <PrivateRoute exact path="/Clientes" component={Clientes} />
          <PrivateRoute exact path="/Proveedores" component={Proveedores} />
          <PrivateRoute exact path="/Empleados" component={Empleados} />
          <PrivateRoute exact path="/Comandas" component={Comandas} />
          <PrivateRoute exact path="/Remitos" component={Remitos} />
          <PrivateRoute exact path="/Empresas" component={Empresas} />
          <PrivateRoute exact path="/Destinos" component={Destinos} />
          <PrivateRoute exact path="/Estados" component={Estados} />
          <PrivateRoute exact path="/Gastos" component={Gastos} />
          <PrivateRoute exact path="/CuentaGastos" component={CuentaGastos} />
          <PrivateRoute exact path="/Metodos" component={Metodos} />
          <PrivateRoute exact path="/Transportes" component={Transportes} />
          <PrivateRoute exact path="/Localidades" component={Localidades} />
          <PrivateRoute exact path="/Choferes" component={Choferes} />
          <PrivateRoute exact path="/Camiones" component={Camiones} />
          <PrivateRoute exact path="/Estaciones" component={Estaciones} />
          <PrivateRoute exact path="/Productos" component={Productos} />
          <PrivateRoute exact path="/Movimientos" component={Movimientos} />
          <PrivateRoute exact path="/Cajas" component={Cajas} />
          <PrivateRoute exact path="/Viajes" component={Viajes} />

          {/* PEAJES */}
          <PrivateRoute
            exact
            path="/importarpeajes"
            component={ImportarPeajes}
          />

          <PrivateRoute
            exact
            path="/resumenespeajes"
            component={ResumenesPeajes}
          />

          {/* SEGUROS */}

          <PrivateRoute
            exact
            path="/seguros"
            component={HomeSeguros}
          />

          <PrivateRoute
            exact
            path="/informeseguros"
            component={InformeSeguros}
          />

          <PrivateRoute
            exact
            path="/polizasseguros"
            component={Seguros}
          />

          {/* informes */}
          <PrivateRoute
            exact
            path="/informeviajestransporte"
            component={InformeViajesTransporte}
          />

          <PrivateRoute
            exact
            path="/informepeajes"
            component={InformePeajes}
          />

          <PrivateRoute
            exact
            path="/informeauditoria"
            component={InformeAuditoria}
          />

          <PrivateRoute
            exact
            path="/informecomandas"
            component={InformeComandas}
          />

          <PrivateRoute
            exact
            path="/informeremitos"
            component={InformeRemitos}
          />

          <PrivateRoute
            exact
            path="/informecajas"
            component={InformeCajas}
          />

          <PrivateRoute
            exact
            path="/informemovimientos"
            component={InformeMovimientos}
          />

          <PrivateRoute
            exact
            path="/informerendiciones"
            component={InformeRendiciones}
          />

          <PrivateRoute
            exact
            path="/informeordencobro"
            component={InformeOrdenCobro}
          />

          <PrivateRoute
            exact
            path="/informeordenpago"
            component={InformeOrdenPago}
          />

          <PrivateRoute
            exact
            path="/informectacte"
            component={InformeCtaCte}
          />

          <PrivateRoute
            exact
            path="/informectactechofer"
            component={InformeCtaCteChofer}
          />

          <PrivateRoute
            exact
            path="/informectacteestacion"
            component={InformeCtaCteEstacion}
          />

          <PrivateRoute
            exact
            path="/informeclipro"
            component={InformeCLiPro}
          />

          <PrivateRoute
            exact
            path="/informetesoreria"
            component={InformeTesoreria}
          />

          <PrivateRoute
            exact
            path="/informechoferes"
            component={InformeChoferes}
          />

          <PrivateRoute
            exact
            path="/informeestaciones"
            component={InformeEstaciones}
          />

          <PrivateRoute
            exact
            path="/informecartera"
            component={InformeCartera}
          />

          <PrivateRoute
            exact
            path="/informe-cheques-echeq"
            component={InformeChequesECheq}
          />

          <PrivateRoute
            exact
            path="/dashboardchequesecheq"
            component={DashboardChequesECheq}
          />

          <PrivateRoute
            exact
            path="/dashboardauditoria"
            component={DashboardAuditoria}
          />

          <PrivateRoute
            exact
            path="/dashboardcombustible"
            component={DashboardCombustible}
          />

          <PrivateRoute
            exact
            path="/dashboardviajes"
            component={DashboardViajes}
          />

          <PrivateRoute
            exact
            path="/historicoviajes"
            component={HistoricoViajes}
          />

          <PrivateRoute
            exact
            path="/informevencimientoschequesecheq"
            component={InformeVencimientosChequesECheq}
          />

          {/* admin extra */}
          <PrivateRoute
            exact
            path="/admin"
            component={Admin}
          />

          <PrivateRoute exact path="/dashboardrentabilidad" component={DashboardRentabilidad} />

          {/* catch-all */}
          <Route path="*">
            {isLoggedIn() ? (
              <Redirect to="/" />
            ) : (
              <Redirect to="/login" />
            )}
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
}